import { useState } from "react";
import { api, BASE, fmtTime, SITE_HOST } from "../api";
import { Logo } from "../components/Logo";

const CONTACT = "info@mioe.com.tr";

// Shown instead of everything else while an operator has the account
// suspended. The API enforces it too (403 account_suspended on webapps,
// credits, account deletion and every API-key call). Data export stays open:
// the customer keeps their KVKK right of access while the matter is open.
export function Suspended({
  email,
  since,
  onLogout,
}: {
  email: string;
  since: number;
  onLogout: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function exportData() {
    setBusy(true);
    setErr(null);
    try {
      const data = await api.exportMyData();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "verilerim.json";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      setErr("Veriler indirilemedi. Tekrar deneyin.");
    } finally {
      setBusy(false);
    }
  }

  async function logout() {
    try {
      await api.logout();
    } finally {
      onLogout();
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card" style={{ width: "min(520px, 100%)" }}>
        <div className="login-brand">
          <Logo size={36} title={SITE_HOST} />
          <h1>Hesabınız askıya alındı</h1>
        </div>
        <p className="muted" style={{ marginTop: 0 }}>
          {email} hesabı {fmtTime(since)} itibarıyla{" "}
          <a href={`${BASE}/kosullar#yasakli-kullanimlar`} target="_blank" rel="noreferrer">
            Kullanıcı Sözleşmesi
          </a>{" "}
          kapsamında askıya alınmıştır.
        </p>
        <ul className="muted" style={{ paddingLeft: 18, lineHeight: 1.6 }}>
          <li>Uygulamalarınızın API erişimi kapalıdır; yeni doğrulama başlatılamaz.</li>
          <li>Uygulama yönetimi ve kredi satın alma bu süre içinde kullanılamaz.</li>
          <li>Hakkınızda tuttuğumuz verileri aşağıdan indirebilirsiniz.</li>
        </ul>
        <p className="muted">
          Bilgi veya itiraz için <a href={`mailto:${CONTACT}`}>{CONTACT}</a> adresine yazın.
        </p>
        {err && <div className="error">{err}</div>}
        <div className="row" style={{ gap: 8, marginTop: 16 }}>
          <button type="button" className="secondary" disabled={busy} onClick={exportData}>
            {busy ? "Hazırlanıyor…" : "Verilerimi indir"}
          </button>
          <button type="button" onClick={logout}>
            Çıkış yap
          </button>
        </div>
      </div>
    </div>
  );
}
